import { useQuery } from '@tanstack/react-query'

import { aspidaClient } from '@/lib/aspida'
import { QueryConfig } from '@/lib/react-query'

import { advertisementKeyFactory, AdvertisementDisplayPosition } from './key'

export type { AdvertisementDisplayPosition } from './key'

export const getAdvertisements = (
  displayPosition: AdvertisementDisplayPosition = 'top'
) => {
  return aspidaClient.v1.advertisements.$get({
    query: { displayPosition },
  })
}

export type UseAdvertisementsOptions = {
  displayPosition?: AdvertisementDisplayPosition
  config?: QueryConfig<typeof getAdvertisements>
}

export const useAdvertisements = ({
  displayPosition = 'top',
  config,
}: UseAdvertisementsOptions = {}) => {
  const queryConfig: QueryConfig<typeof getAdvertisements> = {
    ...config,
    queryKey: advertisementKeyFactory.advertisements(displayPosition),
    queryFn: () => getAdvertisements(displayPosition),
  }
  return useQuery(queryConfig)
}
